export enum TenantImageNameEnum {}
